import styled from 'styled-components'

export const HeaderContainer = styled.header`
  background: white;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};
  min-height: 80px;
  position: relative;
  z-index: 10;

  @media (max-width: 768px) {
    min-height: 0px;
  }
`

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  gap: 24px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    padding: 16px;
  }
`

export const PropertyInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 1;
  min-width: 0;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`

export const RadarChartContainer = styled.div`
  flex-shrink: 0;
`

export const RadarContainer = styled.div`
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 10px;

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
  }
`

export const PropertyDetails = styled.div`
  flex: 1;
  min-width: 0;
`

export const PropertyTitle = styled.h1`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const PropertyMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  flex-wrap: wrap;

  @media (max-width: 768px) {
    font-size: 11px;
  }
`

export const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
`

export const PropertyTags = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    margin-top: 6px;
    gap: 4px;
  }
`

export const PropertyActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    overflow-x: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
  }
`

export const ActionGroup = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-shrink: 0;
    flex-wrap: nowrap;
  }
`

export const HeaderActions = styled.div`
  display: flex;
  gap: 12px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    flex-shrink: 0;
  }
`
